import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultObjectiveResource,
    ObjectiveMutationResourceSchema,
    type ObjectiveResource,
    useObjectiveActions,
} from '../../../../../resource/resources/artifacts/objective/objectiveResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../../../util/utilFunctions';
import { ObjectiveContent } from './ObjectiveContent';

export const ObjectiveCreationDialog = ({
    onClose,
    parentId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: ObjectiveResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const objectiveActions = useObjectiveActions();
    const addObjective = objectiveActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: ObjectiveMutationResourceSchema,
        defaultValues: {
            ...defaultObjectiveResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addObjective.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Objective'}
            resourceType={ResourceType.OBJECTIVE}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <ObjectiveContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
